export const deDE = {
  general: {
    appName: 'splusd-solutions',
    loading: 'Laden...',
    error: 'Ein Fehler ist aufgetreten',
    notFound: 'Seite nicht gefunden',
    goBack: 'Zurück',
    home: 'Startseite',
  },
  navigation: {
    home: 'Startseite',
    about: 'Über uns',
    services: 'Leistungen',
    erp: 'Microsoft Business Central – ERP',
    shopware: 'E-Commerce',
    businessApps: 'Business Apps',
    mobileApps: 'Mobile Apps',
    interfaces: 'Schnittstellen',
    portals: 'Portale',
    salesCockpit: 'salescockpit.io',
    ctoService: 'CTO Service',
    references: 'Referenzen',
    contact: 'Kontakt',
    login: 'Anmelden',
    register: 'Registrieren',
    consulting: 'Beratung',
    development: 'Entwicklung',
    products: 'Produkte',
    digitalizationConsulting: 'Digitalisierungsberatung',
    digitalizationConsultingDesc: 'Strategische Beratung für Ihre digitale Transformation',
    ctoServiceDesc: 'IT-Führungskompetenz nach Bedarf',
    businessAppsDesc: 'Auf dein Unternehmen angepasst',
    shopwareDesc: 'Shopware, eigene Plattformen & Marktplätze',
    erpDesc: 'Integrierte Unternehmenslösungen',
    interfacesDesc: 'Systemintegration und Datenaustausch',
    portalsDesc: 'Kundenportale und Self-Service-Lösungen',
    mobileAppsDesc: 'iOS & Android-Anwendungen',
    salesCockpitDesc: 'Vertriebssteuerung und -optimierung',
  },
  businessApps: {
    challenges: {
      title: 'Typische Herausforderungen mit Business-Anwendungen',
      subtitle: 'Diese häufigen Probleme können wir mit modernen, maßgeschneiderten Business-Apps lösen',
      items: {
        outdatedUI: {
          title: 'Veraltete Benutzeroberflächen',
          description: 'Altmodische, komplizierte Interfaces führen zu Frustration und niedrigen Adoptionsraten bei Mitarbeitern',
          solution: 'Moderne, intuitive Benutzeroberflächen, die auf aktuelle UX-Standards setzen und die Produktivität steigern'
        },
        dataSilos: {
          title: 'Isolierte Datensilos',
          description: 'Informationen sind über verschiedene Systeme verteilt, ohne Verbindung zwischen wichtigen Geschäftsdaten',
          solution: 'Nahtlose Integration aller Anwendungen für einen konsistenten Datenfluss durch das gesamte Unternehmen'
        },
        manualProcesses: {
          title: 'Manuelle Prozesse',
          description: 'Zeitaufwändige manuelle Eingaben und Arbeitsabläufe, die fehleranfällig sind und wertvolle Ressourcen binden',
          solution: 'Automatisierte Workflows, die manuelle Eingriffe minimieren und Effizienz maximieren'
        },
        dataAccess: {
          title: 'Eingeschränkter Datenzugriff',
          description: 'Wichtige Entscheidungsträger haben keinen direkten Zugang zu relevanten Geschäftsdaten',
          solution: 'Flexible Zugriffsmöglichkeiten auf kritische Daten in Echtzeit für fundierte Entscheidungen'
        },
        userAdoption: {
          title: 'Geringe Benutzerakzeptanz',
          description: 'Komplexe Systeme werden von Mitarbeitern umgangen, wodurch Investitionen verschwendet werden',
          solution: 'Benutzerfreundliche Anwendungen, die auf die tatsächlichen Bedürfnisse der Anwender zugeschnitten sind'
        },
        scalability: {
          title: 'Mangelnde Skalierbarkeit',
          description: 'Bestehende Lösungen können nicht mit dem Unternehmenswachstum Schritt halten',
          solution: 'Zukunftssichere Architekturen, die flexibel an veränderte Geschäftsanforderungen angepasst werden können'
        }
      }
    }
  },
  home: {
    hero: {
      title: 'Mehr Freiraum für dein Business',
      subtitle: 'mit digitaler Automatisierung',
      description: 'Weniger manuelle Arbeit. Mehr Effizienz. Bessere Entscheidungen.',
      details: 'Stell dir vor, dein Team verbringt weniger Zeit mit Papierkram, Excel-Listen und manuellen Prozessen – und kann sich stattdessen auf das Wachstum deines Unternehmens konzentrieren. Wir entwickeln maßgeschneiderte Lösungen, optimieren deine Prozesse und vernetzen deine Systeme nahtlos damit diese Vorstellung zur Realität wird.',
      solutions: 'Unsere Lösungen',
      cta: 'Gespräch vereinbaren',
    },
    about: {
      title: 'Über uns',
      content: 'Wir sind Ihr Partner für digitale Transformation.',
    },
    services: {
      title: 'Unsere Leistungen',
      cta: 'Alle Leistungen ansehen',
    },
  },
  challenges: {
    title: 'Kennst du diese Herausforderungen?',
    subtitle: 'Am Häufigsten helfen wir unseren Kunden bei folgenden Herausforderungen:',
    items: {
      noOrientation: {
        title: 'Zu viele Lösungen, keine Orientierung',
        description: 'ERP, CRM, BDE – aber was brauchst du wirklich? Wir helfen dir, die richtigen Tools auszuwählen.',
        solution: 'Wir erstellen eine maßgeschneiderte Tool-Strategie, die genau zu deinen Geschäftszielen passt.'
      },
      noConnectivity: {
        title: 'Fehlende Vernetzung',
        description: 'Systeme arbeiten isoliert, Daten sind nicht verfügbar – wir sorgen für eine nahtlose Integration.',
        solution: 'Wir implementieren Schnittstellen und schaffen ein zusammenhängendes Ökosystem.'
      },
      noAutomation: {
        title: 'Kaum Automatisierung',
        description: 'Wir ersetzen doppelte Eingaben und Papierformulare durch smarte, automatisierte Workflows.',
        solution: 'Mit klugen Automatisierungen reduzieren wir manuelle Eingriffe und steigern deine Effizienz.'
      },
      noRealtime: {
        title: 'Keine Echtzeit-Übersicht',
        description: 'Lagerbestände, Produktion, Lieferzeiten – wir schaffen Transparenz mit Daten, die für dich arbeiten.',
        solution: 'Wir entwickeln maßgeschneiderte Dashboards für schnelle, fundierte Entscheidungen.'
      },
      noIT: {
        title: 'Überlastete IT oder fehlende Fachkräfte',
        description: 'Kein eigenes Digitalteam? Kein Problem. Wir bringen das Know-how und die Kapazität mit.',
        solution: 'Als dein externer Digitalisierungspartner übernehmen wir genau die Aufgaben, die du benötigst.'
      },
      competition: {
        title: 'Wettbewerbsnachteil',
        description: 'Die Konkurrenz ist digitaler, schneller, günstiger? Wir helfen dir, den Anschluss nicht zu verlieren.',
        solution: 'Mit unserer Strategie verschaffst du dir klare Wettbewerbsvorteile durch Digitalisierung.'
      }
    }
  },
  serviceModels: {
    title: 'Wie wir zusammenarbeiten',
    subtitle: 'Wir passen uns flexibel an deine Bedürfnisse an - als vollständiger Umsetzer oder als strategischer Sparringspartner',
    items: {
      weBuild: {
        title: '"We Build It" - Wir setzen es für euch um',
        description: 'Ihr braucht eine fertige Lösung, ohne euch um technische Details kümmern zu müssen? Wir übernehmen die gesamte Umsetzung - von der Strategie bis zur technischen Realisierung.',
        idealFor: 'Ideal für Unternehmen, die schnell eine Lösung brauchen, aber selbst keine internen Ressourcen haben.'
      },
      weEmpower: {
        title: '"We Empower You" - Enablement & Sparring',
        description: 'Euer Team möchte selbst an der Umsetzung arbeiten, aber es fehlt die Orientierung? Wir stehen euch als Sparringspartner zur Seite, geben Wissen, Best Practices und klare Strategien weiter, damit ihr langfristig unabhängig arbeitet.',
        idealFor: 'Ideal für Unternehmen, die intern Kompetenzen aufbauen und sich strategisch weiterentwickeln möchten.'
      }
    }
  },
  strategyDirection: {
    title: 'Strategy + Direction',
    subtitle: 'Mit unserem Beratungsangebot "Strategy + Direction" entwickeln wir eine klare Strategie, die Digitalisierung, Automatisierung und Softwareintegration passgenau für dein Unternehmen umsetzt.',
    stepPrefix: 'Schritt',
    steps: {
      step1: {
        title: 'Analyse deines Status quo',
        description: 'Wir verstehen deine aktuellen Prozesse, Systeme und Herausforderungen.'
      },
      step2: {
        title: 'Entwicklung einer Digital-Roadmap',
        description: 'Wir erstellen einen maßgeschneiderten Plan für deine digitale Transformation.'
      },
      step3: {
        title: 'Umsetzung & Optimierung',
        description: 'Wir begleiten dich bei der Implementierung und kontinuierlichen Verbesserung.'
      }
    },
    moduleIntro: 'So richtest du dein Business zukunftssicher aus und schaffst die Basis für effiziente, skalierbare Prozesse.',
    modules: {
      module1: {
        title: 'MODUL I: SOFTWARE + DATA',
        description: 'Effiziente Software. Klare Daten. Smarte Entscheidungen.',
        bulletPoints: [
          'Software-Auswahl: Welche Software passt zu meinen Anforderungen?',
          'Datenerfassung: Wie sammeln wir relevante Daten?',
          'Datenanalyse: Wie werten wir die Daten aus?',
          'Systemintegration: Wie lassen wir Systeme miteinander kommunizieren?',
          'Automatisierung: Wo können Businessanwendungen Arbeit sparen?'
        ],
        highlight: '🚀 Passgenaue Softwarelösungen und Datenstrukturen für fundierte Geschäftsentscheidungen'
      },
      module2: {
        title: 'MODUL II: AUTOMATION + KI',
        description: 'Zeit sparen, Fehler reduzieren, Team entlasten',
        bulletPoints: [
          'Automatisierung wiederkehrender Prozesse & Aufgaben',
          'KI-gestützte Datenanalyse und Entscheidungshilfen',
          'Chatbots & intelligente Assistenten für interne Abläufe',
          'Dokumentenverarbeitung mit KI (Rechnungen, Verträge, etc.)'
        ],
        highlight: '🚀 Künstliche Intelligenz und smarte Workflows für mehr Effizienz und weniger Aufwand'
      },
      module3: {
        title: 'MODUL III: DIGITAL COMMERCE',
        description: 'Dein Vertrieb, digital und zukunftssicher',
        bulletPoints: [
          'Entwicklung moderner Online-Shops (B2C & B2B)',
          'Digitale Produkte & Abo-Modelle für neue Umsatzquellen',
          'Kundenportale für verbesserte Kundenbindung',
          'Optimierung der Customer Journey & Conversion Rate'
        ],
        highlight: '🚀 Technologie, Funktionalität und Benutzerfreundlichkeit für nachhaltiges Wachstum'
      }
    },
    ctaText: 'Zum Strategy + Direction Angebot',
    ctaDescription: '👉 Gemeinsam analysieren wir dein Unternehmen und setzen eine digitale Strategie um, die sich wirklich auszahlt.'
  },
  calculator: {
    title: 'Einsparpotenzial-Rechner',
    description: 'Berechne, wie viel dein Unternehmen durch die Digitalisierung und Automatisierung manueller Prozesse einsparen kann.',
    cardTitle: 'Einsparpotenzial berechnen',
    cardDescription: 'Wie viel Zeit und Geld kannst du durch Automatisierung sparen?',
    employees: {
      label: 'Anzahl der Mitarbeiter',
      description: 'Wie viele Mitarbeiter führen den Prozess aus?'
    },
    minutes: {
      label: 'Minuten pro Durchführung',
      description: 'Zeit pro manuellem Prozess in Minuten'
    },
    frequency: {
      daily: 'Täglich',
      weekly: 'Wöchentlich'
    },
    hourlyRate: {
      label: 'Kosten pro Stunde (€)',
      description: 'Stundensatz inkl. Lohnnebenkosten',
      source: 'Quelle: Statistisches Bundesamt'
    },
    workingDays: {
      label: 'Arbeitstage pro Jahr',
      description: 'Durchschnittliche Arbeitstage im Jahr'
    },
    result: {
      label: 'Dein jährliches Einsparpotenzial:',
      threeYears: 'Nach 3 Jahren: {{amount}} € gespart'
    },
    benefits: {
      title: 'Zusätzliche Vorteile:',
      satisfaction: 'Höhere Mitarbeiterzufriedenheit',
      errors: 'Geringere Fehlerquote',
      response: 'Schnellere Reaktionszeiten',
      service: 'Besserer Kundenservice',
      focus: 'Fokus auf wertschöpfende Tätigkeiten',
      scalability: 'Bessere Skalierbarkeit'
    },
    cta: 'Jetzt Potenzial erschließen'
  },
  faq: {
    title: 'Häufig gestellte Fragen',
    subtitle: 'Alles, was du über die Zusammenarbeit mit uns wissen musst',
    items: [
      {
        question: "Wie lange dauert ein typisches Digitalisierungsprojekt?",
        answer: "Die Dauer variiert je nach Umfang und Komplexität. Eine erste Digitalisierungsstrategie entwickeln wir innerhalb von 2-4 Wochen. Konkrete Umsetzungsprojekte können von wenigen Wochen bis zu mehreren Monaten dauern. Wir arbeiten agil und liefern schnelle, messbare Erfolge, anstatt auf große \"Big Bang\"-Lösungen zu setzen."
      },
      {
        question: "Benötige ich technisches Vorwissen für die Zusammenarbeit?",
        answer: "Nein, überhaupt nicht. Wir übersetzen komplexe technische Themen in verständliche Sprache und Konzepte. Unsere Aufgabe ist es, dir die Digitalisierung so einfach wie möglich zu machen – du musst nur wissen, welche Geschäftsziele du erreichen willst."
      },
      {
        question: "Was kostet die Digitalisierung meines Unternehmens?",
        answer: "Die Kosten hängen stark von deinen individuellen Anforderungen und dem Umfang des Projekts ab. Wir bieten aber flexible Modelle, von der punktuellen Beratung bis zur kompletten Umsetzung. Ein kostenloses Erstgespräch gibt dir erste Orientierung zu möglichen Kosten und dem zu erwartenden ROI. Wichtig ist: Digitalisierung ist keine Ausgabe, sondern eine Investition mit messbarem Mehrwert."
      },
      {
        question: "Kann ich Digitalisierung schrittweise angehen oder muss ich alles auf einmal umsetzen?",
        answer: "Definitiv schrittweise! Wir empfehlen sogar einen modularen Ansatz, bei dem wir mit den Bereichen beginnen, die den schnellsten ROI bringen. So kannst du früh Erfolge sehen und die Digitalisierung Schritt für Schritt ausbauen. Unsere digitale Roadmap gibt dir einen klaren Fahrplan für diesen Weg."
      },
      {
        question: "Wie lange dauert es, bis ich Ergebnisse der Digitalisierung sehe?",
        answer: "Erste Ergebnisse sind oft schon nach wenigen Wochen sichtbar. Wir setzen auf schnelle Wins und messbare Verbesserungen. Unser Ziel ist es, dass du bereits im ersten Monat der Zusammenarbeit konkrete Vorteile wie Zeitersparnis oder Prozessverbesserungen erlebst."
      }
    ]
  },
  contact: {
    title: 'Kontakt',
    description: 'Bei Fragen oder für weitere Informationen können Sie uns jederzeit kontaktieren.',
    addressTitle: 'Adresse',
    contactInfoTitle: 'Kontaktinformationen',
    phone: 'Telefon',
    email: 'E-Mail',
    form: {
      name: 'Name',
      email: 'E-Mail',
      phone: 'Telefon',
      company: 'Unternehmen',
      message: 'Nachricht',
      submit: 'Jetzt Gespräch vereinbaren',
      sending: 'Wird gesendet...',
      success: 'Vielen Dank für Ihre Anfrage!',
      successDescription: 'Wir werden uns in Kürze bei Ihnen melden.',
      error: 'Fehler beim Senden',
      errorDescription: 'Bitte versuchen Sie es später erneut.',
      errorTechnical: 'Es gab ein technisches Problem. Bitte versuchen Sie es später erneut.',
      consent: 'Ich stimme der Verarbeitung meiner Daten zu',
      consentInfo: 'Wir verwenden Ihre Daten ausschließlich zur Bearbeitung Ihrer Anfrage gemäß unserer Datenschutzerklärung.',
      disclaimer: 'Mit dem Absenden stimmst du unseren Datenschutzbestimmungen zu und erlaubst uns, dich bezüglich deiner Anfrage zu kontaktieren.',
      title: 'Lass mal quatschen...'
    },
    cta: {
      title: '🚀 Jetzt durchstarten – mit einem kostenlosen Erstgespräch!',
      description: '🎯 In nur 30 Minuten klären wir, wie du deine Prozesse effizienter machst und Kosten sparst.'
    },
    info: {
      title: 'Wir sind für dich da',
      description: 'Vereinbare ein unverbindliches Erstgespräch oder sende uns eine Nachricht. Wir melden uns innerhalb von 24 Stunden bei dir zurück.',
      callUs: 'Ruf uns an',
      emailUs: 'Schreib uns eine E-Mail',
      officeHours: 'Bürozeiten',
      officeHoursTime: 'Montag - Freitag, 9:00 - 16:00 Uhr',
      expectationsTitle: 'Das kannst du von uns erwarten:',
      expectations: {
        1: 'Persönliche Beratung zu deinen Herausforderungen',
        2: 'Kein Fließband-Service, sondern individuelle Beratung',
        3: 'Klare, nachvollziehbare Lösungswege ohne Fachjargon',
        4: 'Keine Verpflichtungen nach dem Erstgespräch'
      }
    }
  },
  footer: {
    copyright: '© 2023 splusd-solutions. Alle Rechte vorbehalten.',
    privacy: 'Datenschutz',
    terms: 'AGB',
    imprint: 'Impressum',
  },
  common: {
    form: {
      name: 'Name',
      email: 'E-Mail',
      company: 'Unternehmen',
      phone: 'Telefon',
      message: 'Nachricht',
      submit: 'Absenden',
      required: 'Pflichtfeld',
      privacyNotice: 'Mit dem Absenden des Formulars erklärst du dich damit einverstanden, dass wir deine Daten gemäß unserer Datenschutzerklärung verarbeiten.'
    }
  },
}; 